module.exports = __webpack_public_path__ + "static/media/A2.5cc03871.jpg";